import { cn } from "@src/lib/utils"
import { css } from "@emotion/css"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md",
        css`
          background: linear-gradient(
            90deg,
            hsl(var(--muted)) 0%,
            hsl(var(--muted) / 0.6) 50%,
            hsl(var(--muted)) 100%
          );
          background-size: 200% 100%;
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite,
            shimmer 2s linear infinite;
        `,
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
